export enum ExportPersonTypeEnum {
  CONTACT = 'contact',
  LEAD = 'lead',
}


